import { finalize } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { environment } from '@environments/environment';
import { InputTextComponent } from '@components/input-text/input-text.component';
import { LoadingButtonComponent } from '@components/loading-button/loading-button.component';
import { NavButtonComponent } from '@components/nav-button/nav-button.component';
import { MessageToastService } from '@services/message-toast.service';
import { LoginBusinessService } from './logic/login-business.service';
import { LoginFormModel } from '../../shared/form/login-form.model';

declare const grecaptcha: any;

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    LoadingButtonComponent,
    InputTextComponent,
    NavButtonComponent,
  ],
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  public loginFormModel!: LoginFormModel;
  public loading: boolean = false;

  public get loginForm() {
    return this.loginFormModel.form;
  }

  constructor(
    private fb: FormBuilder,
    private loginBusinessService: LoginBusinessService,
    private toastService: MessageToastService
  ) {}

  ngOnInit(): void {
    this.loginFormModel = new LoginFormModel(this.fb, this.toastService);
  }

  onSubmit(): void {
    if (!this.loginFormModel.validate()) return;
    this.loading = true;
    grecaptcha.ready(() => {
      grecaptcha
        .execute(environment.recaptchaSiteKey, {
          action: 'login',
        })
        .then((token: string) => {
          this.authenticateUser(token);
        })
        .catch(() => {
          this.loading = false;
          this.loginBusinessService.handleRecaptchaError();
        });
    });
  }

  private authenticateUser(recaptchaToken: string): void {
    const credentials = this.loginFormModel.getCredentials();
    this.loginBusinessService
      .login(credentials, recaptchaToken)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (auth) => this.loginBusinessService.handleLoginSuccess(auth),
        error: (err) =>
          this.loginBusinessService.handleLoginError(err, credentials),
      });
  }
}
